module.exports = __webpack_public_path__ + "img/zhuanpan.bb0e6964.png";